import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import MaterialType from '../../types/api/stamp-material-types/models/material-type'
import Strapi, { EndpointQueryParameters } from '../../types/strapi/strapi'
import getQuery from '../../helpers/api/get-query'

export const materialTypesApi = createApi({
    reducerPath: 'materialTypesApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['MaterialTypes'],
    endpoints: builder => ({
        getMaterialTypes: builder.query<Strapi<MaterialType>, EndpointQueryParameters | void>({
            query: getQuery('/material-types'),
        }),
    }),
})

export const { useGetMaterialTypesQuery } = materialTypesApi
